export { default as ContentfulToolbar } from './ContentfulToolbar';
